import React, { CSSProperties } from "react";
import { FieldRenderProps } from "react-final-form";
import styled from "styled-components";

import { FieldInput } from "./FieldInput";

type Props = FieldRenderProps<string, HTMLElement> & {
  className?: string;
  label?: string;
  style?: CSSProperties;
  wrapperStyling?: CSSProperties;
  disabled?: boolean;
};

export const DatePicker: React.FC<Props> = ({
  className,
  input,
  label,
  meta: { error },
  style,
  wrapperStyling,
  disabled = false,
}) => {
  return (
    <Wrapper style={wrapperStyling} disabled={disabled}>
      <FieldInput
        className={className}
        error={error}
        style={style}
        {...input}
        label={label}
        name={input.name}
        onChange={input.onChange}
        type="date"
        value={input.value}
      />
    </Wrapper>
  );
};

const Wrapper = styled.div<{ disabled?: boolean }>`
${({ disabled }) =>
  disabled &&
  `> *:not(.no-disable) {
    opacity: 0.25;
    pointer-events: none;
  }`}
  margin: 24px;
`;
